import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { RESEND_MAIL, RESEND_MAIL_SUCCESS, RESEND_MAIL_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* resendMail({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/communications`,
      method: 'POST',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: RESEND_MAIL_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: RESEND_MAIL_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: RESEND_MAIL_ERROR, payload: error });
  }
}

export function* watchResendMail() {
  yield takeEvery(RESEND_MAIL, resendMail);
}

function* resendMailSaga() {
  yield all([fork(watchResendMail)]);
}

export default resendMailSaga;
